import clsx, { ClassValue } from 'clsx';
import { isNil } from 'lodash';
import { grid } from '@shared/styles/grid';
import { IconName, IconNameMap } from './iconNameMap';
import styles from './Icon.module.css';

export interface IconProps {
  name?: IconName;
  color?: string;
  gridSize?: number;
  className?: ClassValue;
  testID?: string;
}

const DEFAULT_ICON_GRID_SIZE = 5;

/**
 * Renders a single-color line-art icon from the v2 set by name. `color` tints via `currentColor`
 * and defaults to the inherited text color. Multicolor art is not an `IconName`; import and
 * render its SVG directly instead.
 */
export function Icon({
  name,
  color,
  gridSize = DEFAULT_ICON_GRID_SIZE,
  className,
  testID,
}: IconProps) {
  const Svg = isNil(name) ? undefined : IconNameMap[name];
  if (isNil(Svg)) {
    return null;
  }

  const size = grid(gridSize);
  return (
    <Svg
      width={size}
      height={size}
      color={color}
      className={clsx(styles.icon, className)}
      data-testid={testID}
      aria-hidden
    />
  );
}
